import { UserNotificationConstants } from 'finhelper';
import type { RoboadvisorStatusData } from '#app/types/roboStatus';
import type {
  RoboadvisorNotificationItem,
  RoboadvisorNotificationsResponse,
} from '#app/types/roboNotifications';

export interface MockRoboadvisorItem {
  id: number;
  uuid: string;
  user_id: number;
  account_id: string;
  client_type: string;
  strategy?: string;
}

const MOCK_ROBOADVISORS: MockRoboadvisorItem[] = [
  {
    id: 111,
    uuid: 'mock-robo-111',
    user_id: 5368,
    account_id: 'MOCK-ACC-111',
    client_type: 'bcs',
    strategy: 'mock-strategy-111',
  },
  {
    id: 112,
    uuid: 'mock-robo-112',
    user_id: 5368,
    account_id: 'MOCK-ACC-112',
    client_type: 'aton',
    strategy: 'mock-strategy-112',
  },
];

const MOCK_ROBO_STATUS_DATA: RoboadvisorStatusData = {
  internal_id: 'mock-internal-id',
  account_id: null,
  rebalance_connected: true,
  execution_connected: false,
  can_rebalance: true,
  last_rebalancing_time: '2026-04-08 12:30:00',
  message: 'Mock robo status response',
};

const MOCK_ROBO_NOTIFICATIONS: RoboadvisorNotificationItem[] = [
  {
    id: 7151,
    content: 'Синхронизация с БКС успешно выполнена.',
    user_id: 5368,
    status: UserNotificationConstants.CONFIRMED,
    action_id: null,
    created_at: '2026-04-08 12:20:27',
    data: null,
  },
  {
    id: 7145,
    content:
      'При загрузке брокерского отчета «Атон» не найдено количество средств на конец периода.',
    user_id: 5368,
    status: UserNotificationConstants.CREATED,
    action_id: UserNotificationConstants.NOT_FOUND_MONEY_ON_DATE,
    created_at: '2026-04-08 12:20:27',
    data: null,
  },
  {
    id: 7140,
    content: 'Ошибка синхронизации с Атон. Проверьте файл отчета и повторите попытку.',
    user_id: 5368,
    status: UserNotificationConstants.CREATED,
    action_id: UserNotificationConstants.ROBO_ERROR,
    created_at: '2026-04-08 11:18:03',
    data: null,
  },
];

export const getMockRoboadvisorList = (
  clientId: number | string | undefined
): MockRoboadvisorItem[] => {
  if (!clientId) return MOCK_ROBOADVISORS;
  return MOCK_ROBOADVISORS.filter((item) => String(item.user_id) === String(clientId));
};

export const getMockRoboadvisorById = ({
  clientId,
  roboId,
}: {
  clientId: number | string;
  roboId: number | string;
}): MockRoboadvisorItem | null => {
  const filtered = getMockRoboadvisorList(clientId);
  return filtered.find((item) => String(item.id) === String(roboId)) || null;
};

export const getMockRoboadvisorStatus = (_roboId: number | string): RoboadvisorStatusData => {
  return MOCK_ROBO_STATUS_DATA;
};

export const getMockRoboadvisorNotifications = ({
  pageParam,
  perPage,
}: {
  pageParam: number;
  perPage: number;
}): RoboadvisorNotificationsResponse => {
  const from = (pageParam - 1) * perPage;
  const to = from + perPage;
  const pagedData = MOCK_ROBO_NOTIFICATIONS.slice(from, to);

  return {
    data: pagedData,
    meta: {
      current_page: pageParam,
      last_page: Math.max(1, Math.ceil(MOCK_ROBO_NOTIFICATIONS.length / perPage)),
      per_page: perPage,
      total: MOCK_ROBO_NOTIFICATIONS.length,
    },
  };
};
